module.exports = __webpack_public_path__ + "img/icons_Prancheta 1-50.4eedab30.svg";